import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row align-items-end mb-4" }
const _hoisted_2 = { class: "col-md-7 position-relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Date range", -1)
const _hoisted_4 = { class: "input-icon" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-event icon-white" }, null, -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "range-panel shadow-sm"
}
const _hoisted_8 = { class: "d-flex gap-2 mb-3" }
const _hoisted_9 = { class: "d-flex gap-4 mb-6" }
const _hoisted_10 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_11 = { class: "col-md-5 d-flex gap-2 mt-4 mt-md-0 justify-content-end" }
const _hoisted_12 = { class: "row mb-5" }
const _hoisted_13 = { class: "col-md-3 mb-5 mb-md-0" }
const _hoisted_14 = { class: "card h-100" }
const _hoisted_15 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Users", -1)
const _hoisted_17 = { class: "fs-2 fw-bold" }
const _hoisted_18 = { class: "fs-7 text-muted" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-people fs-1",
  style: {"color":"#F50242"}
}, null, -1)
const _hoisted_20 = { class: "col-md-3 mb-5 mb-md-0" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "AdRewards", -1)
const _hoisted_24 = { class: "fs-2 fw-bold" }
const _hoisted_25 = { class: "fs-7 text-muted" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-cash-stack fs-1",
  style: {"color":"#F50242"}
}, null, -1)
const _hoisted_27 = { class: "col-md-3 mb-5 mb-md-0" }
const _hoisted_28 = { class: "card h-100" }
const _hoisted_29 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Coupons", -1)
const _hoisted_31 = { class: "fs-2 fw-bold" }
const _hoisted_32 = { class: "fs-7 text-muted" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-ticket-perforated fs-1",
  style: {"color":"#F50242"}
}, null, -1)
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "card h-100" }
const _hoisted_36 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Missions", -1)
const _hoisted_38 = { class: "fs-2 fw-bold" }
const _hoisted_39 = { class: "fs-7 text-muted" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-coin fs-1",
  style: {"color":"#F50242"}
}, null, -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-12 col-xl-12 col-xxl-6 mb-5" }
const _hoisted_43 = { class: "card card-flush overflow-hidden h-md-100" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Coins per month")
  ])
], -1)
const _hoisted_45 = { class: "card-body d-flex justify-content-between flex-column pb-1" }
const _hoisted_46 = { class: "px-9" }
const _hoisted_47 = { class: "col-lg-12 col-xl-12 col-xxl-6 mb-5" }
const _hoisted_48 = { class: "card card-flush overflow-hidden h-md-100" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Users per month")
  ])
], -1)
const _hoisted_50 = { class: "card-body d-flex justify-content-between flex-column pb-1" }
const _hoisted_51 = { class: "px-9" }
const _hoisted_52 = {
  key: 0,
  class: "col-lg-6 col-xl-6 mb-5 mb-xl-0"
}
const _hoisted_53 = { class: "card card-flush overflow-hidden h-md-100" }
const _hoisted_54 = { class: "card-header py-5" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Users per country (Top 8)")
], -1)
const _hoisted_56 = {
  class: "ms-auto",
  style: {"min-width":"220px"}
}
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "card-body d-flex justify-content-between flex-column pb-6 pt-6" }
const _hoisted_59 = { class: "px-9" }
const _hoisted_60 = {
  key: 1,
  class: "productSales col-lg-12 col-xl-12 col-xxl-5 mb-5 mb-xl-0 chart-container"
}
const _hoisted_61 = { class: "card card-flush overflow-hidden h-md-100" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Top 5 product sales")
  ])
], -1)
const _hoisted_63 = { class: "card-body d-flex justify-content-between flex-column pb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("input", {
            type: "text",
            class: "form-control ps-10 date-input",
            value: _ctx.displayRange,
            readonly: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRangePicker = !_ctx.showRangePicker))
          }, null, 8, _hoisted_6)
        ]),
        (_ctx.showRangePicker)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control date-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDateIso) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.startDateIso]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control date-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDateIso) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.endDateIso]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", {
                  class: "mr-4",
                  style: {"text-decoration":"underline","color":"#ccc"},
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setToday && _ctx.setToday(...args)))
                }, "Today"),
                _createElementVNode("a", {
                  class: "mr-4",
                  style: {"text-decoration":"underline","color":"#ccc"},
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setLastDay && _ctx.setLastDay(...args)))
                }, "Last day"),
                _createElementVNode("a", {
                  class: "mr-4",
                  style: {"text-decoration":"underline","color":"#ccc"},
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setLastMonth && _ctx.setLastMonth(...args)))
                }, "Last month"),
                _createElementVNode("a", {
                  class: "mr-4",
                  style: {"text-decoration":"underline","color":"#ccc"},
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setThisMonth && _ctx.setThisMonth(...args)))
                }, "This month"),
                _createElementVNode("a", {
                  class: "",
                  style: {"text-decoration":"underline","color":"#ccc"},
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setThisYear && _ctx.setThisYear(...args)))
                }, "Last year")
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-primary btn-sm",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyDateFilter && _ctx.applyDateFilter(...args)))
                }, "Apply"),
                _createElementVNode("button", {
                  class: "btn btn-light btn-sm",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearDateFilter && _ctx.clearDateFilter(...args)))
                }, "Clear"),
                _createElementVNode("button", {
                  class: "btn btn-outline-light btn-sm",
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showRangePicker = false))
                }, "Close")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.applyDateFilter && _ctx.applyDateFilter(...args)))
        }, " Apply "),
        _createElementVNode("button", {
          class: "btn btn-light",
          type: "button",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearDateFilter && _ctx.clearDateFilter(...args)))
        }, " Clear ")
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", null, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.dashboardSummary.user_Period), 1),
              _createElementVNode("div", _hoisted_18, "Total: " + _toDisplayString(_ctx.dashboardSummary.users), 1)
            ]),
            _hoisted_19
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", null, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.adRewardPeriod), 1),
              _createElementVNode("div", _hoisted_25, "Total: " + _toDisplayString(_ctx.adRewardTotal), 1)
            ]),
            _hoisted_26
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", null, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.dashboardSummary.coupons_Period) + " (" + _toDisplayString(_ctx.formattedCoinsPeriod) + " coins)", 1),
              _createElementVNode("div", _hoisted_32, "Total: " + _toDisplayString(_ctx.dashboardSummary.coupons) + " (" + _toDisplayString(_ctx.formattedCoinsTotal) + " coins)", 1)
            ]),
            _hoisted_33
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.dashboardSummary.missions_Completed_Period), 1),
              _createElementVNode("div", _hoisted_39, "Total: " + _toDisplayString(_ctx.dashboardSummary.missions_Completed_Period), 1)
            ]),
            _hoisted_40
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", null, [
                _createVNode(_component_apexchart, {
                  type: "line",
                  options: _ctx.coinsChartOptions,
                  series: _ctx.coinsChartSeries
                }, null, 8, ["options", "series"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", null, [
                _createVNode(_component_apexchart, {
                  type: "bar",
                  options: _ctx.usersChartOptions,
                  series: _ctx.usersChartSeries
                }, null, 8, ["options", "series"])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.usersCountryChartSeries && _ctx.usersCountryChartSeries.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedUsersCountryMonth) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersCountryChartMonths, (m) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: m.key,
                        value: m.key
                      }, _toDisplayString(m.label), 9, _hoisted_57))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedUsersCountryMonth]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_apexchart, {
                      type: "pie",
                      options: _ctx.usersCountryChartOptions,
                      series: _ctx.usersCountryChartSeries
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (
        _ctx.getProductSales &&
        _ctx.getProductLabels &&
        _ctx.getProductSales.length > 0 &&
        _ctx.getProductLabels.length > 0
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_apexchart, {
                  type: "pie",
                  options: 
              _ctx.ChartsConfigurations.dashboardProductSalesPieOptions(
                _ctx.getProductLabels
              )
            ,
                  series: _ctx.getProductSales
                }, null, 8, ["options", "series"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}